import { Education } from '../types';

export const education: Education[] = [
  {
    title: 'Bachelors Degree',
    institution: 'Complutense University of Madrid',
    period: '1997 - 2001',
    description: 'Technical Engineer in Management Informatics.',
  },
  {
    title: 'Certified',
    institution: 'AWS',
    period: 'September 2023',
    description: 'AWS Certified SysOps Administrator-Associate (SOA-C02) - Expires September 2026.',
  },
  {
    title: 'Certified',
    institution: 'Udemy Course',
    period: 'March 2023',
    description: 'HashiCorp Certified: Terraform Associate (002) Expires on March 13, 2025.',
  },
  {
    title: 'Course Diploma',
    institution: 'Udemy',
    period: 'February 2023',
    description: 'Microservices with Node JS and React',
  },
  {
    title: 'Course Diploma',
    institution: 'Egghead',
    period: 'February 2023',
    description: 'Build a Realtime Chat App with Remix and Supabase',
  },
  {
    title: 'Course Diploma',
    institution: 'Udemy',
    period: 'December 2020',
    description: 'Docker and Kubernetes: The Complete Guide',
  },
  {
    title: 'Course Diploma',
    institution: 'Udemy',
    period: 'December 2020',
    description: 'NestJS - Modern TypeScript Back-end Development',
  },
  {
    title: 'Certified',
    institution: 'Udemy Course',
    period: 'September 2020',
    description: 'AWS Certified Solutions Architect - Associate (SAA) - Expires September 2023',
  },
  {
    title: 'Course',
    institution: 'Egghead',
    period: 'June 2023',
    description: 'Get Started with AI-Driven App Development Using the OpenAI Node.js SDK',
  },
];
